import * as React from 'react';
import { IClock, defaultClock } from 'core';

export const ClockContext = React.createContext<IClock>(defaultClock());

export function useClock(): IClock {
  const context = React.useContext(ClockContext);
  return context;
}
